// MG Product Swatches export: page Swatch Picker sections
window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};
window.MG_SWATCH_SETS["Colors-LW08"] = {
  "meta": {
    "appearance": {
      "border_color": "#767676",
      "border_size": 2,
      "shadow_size": 4,
      "background_color": "transparent",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 20,
      "text_size_desktop": 30,
      "border_radius_px": 6,
      "image_radius_px": 6,
      "product_image_padding": 2,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 10,
      "background_color": "transparent",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 20,
      "text_size_desktop": 30,
      "border_radius_px": 6,
      "image_radius_px": 6,
      "product_image_padding": 0,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 6
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Light",
          "alt": "Light",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Jar-InFrontOfSwatch.png?v=1775828854&width=400",
          "product_url": "/products/lw_lite_s",
          "product_id": 7572121550982,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$22.99",
          "price_num": 22.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/lw_lite_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bleached",
          "alt": "Bleached",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Jar-InFrontOfSwatch_0f18d687-9286-4f76-9588-f7bc2aaed95b.png?v=1775828948&width=400",
          "product_url": "/products/lw_blch_s",
          "product_id": 7572161921158,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$22.99",
          "price_num": 22.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/lw_blch_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark",
          "alt": "Dark",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Jar-InFrontOfSwatch_0c2333cd-9d5a-4ed9-a230-232174c59483.png?v=1775829000&width=400",
          "product_url": "/products/lw_dark_s",
          "product_id": 7572175552646,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$22.99",
          "price_num": 22.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/lw_dark_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Wood Finish Kits",
          "alt": "Wood Finish Kits",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-POAK-3D.png?v=1778167046&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_s",
          "product_id": 6829867237510,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$69.99",
          "price_num": 69.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_s",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-LW16"] = {
  "meta": {
    "match_settings_preset_key": "Colors-LW08"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Light",
          "alt": "Light",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW16-LITE-8.png?v=1774459541&width=400",
          "product_url": "/products/retq-lightwood",
          "product_id": 6701984055430,
          "price": "$32.99",
          "price_num": 32.99,
          "available": true,
          "cta": {
            "href": "/products/retq-lightwood",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bleached",
          "alt": "Bleached",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW16-BLCH-8.png?v=1774460968&width=400",
          "product_url": "/products/retq-bleachedwood",
          "product_id": 1943603150966,
          "price": "$29.99",
          "price_num": 29.99,
          "available": true,
          "cta": {
            "href": "/products/retq-bleachedwood",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark",
          "alt": "Dark",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW16-DARK-8.png?v=1774461428&width=400",
          "product_url": "/products/retq-darkwood",
          "product_id": 5187077865606,
          "price": "$32.99",
          "price_num": 32.99,
          "available": true,
          "cta": {
            "href": "/products/retq-darkwood",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Wood Finish Kit",
          "alt": "Wood Finish Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-3D_098d1bf5-3165-42f4-8196-9af3722dc471.png?v=1776107846&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_m",
          "product_id": 6829925728390,
          "price": "$109.99",
          "price_num": 109.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-LW32"] = {
  "meta": {
    "match_settings_preset_key": "Colors-LW08"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Light",
          "alt": "Light",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW32-LITE-8.png?v=1774459491&width=400",
          "product_url": "/products/lw_lite_l",
          "product_id": 7572124762246,
          "price": "$39.99",
          "price_num": 39.99,
          "available": true,
          "cta": {
            "href": "/products/lw_lite_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bleached",
          "alt": "Bleached",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW32-BLCH-8.png?v=1774460493&width=400",
          "product_url": "/products/lw_blch_l",
          "product_id": 7572163526790,
          "price": "$39.99",
          "price_num": 39.99,
          "available": true,
          "cta": {
            "href": "/products/lw_blch_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark",
          "alt": "Dark",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/InFrontOfSwatch_d01406f0-ffef-42a7-9986-f75c248e46f7.png?v=1777578142&width=400",
          "product_url": "/products/lw_dark_l",
          "product_id": 7572175683718,
          "price": "$39.99",
          "price_num": 39.99,
          "available": true,
          "cta": {
            "href": "/products/lw_dark_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Wood Finish Kits",
          "alt": "Wood Finish Kits",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-POAK.png?v=1776107881&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_l",
          "product_id": 6829915701382,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-LW128"] = {
  "meta": {
    "match_settings_preset_key": "Colors-LW08"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Light",
          "alt": "Light",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW128-LITE-8.png?v=1774459846&width=400",
          "product_url": "/products/lw_lite_xl",
          "product_id": 7572125286534,
          "price": "$159.99",
          "price_num": 159.99,
          "available": true,
          "cta": {
            "href": "/products/lw_lite_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bleached",
          "alt": "Bleached",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW128-BLCH-8.png?v=1774460336&width=400",
          "product_url": "/products/lw_blch_xl",
          "product_id": 7572164116614,
          "price": "$159.99",
          "price_num": 159.99,
          "available": true,
          "cta": {
            "href": "/products/lw_blch_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark",
          "alt": "Dark",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW128-DARK-8.png?v=1774461680&width=400",
          "product_url": "/products/lw_dark_xl",
          "product_id": 7572175716486,
          "price": "$159.99",
          "price_num": 159.99,
          "available": false,
          "cta": {
            "href": "/products/lw_dark_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Wood Finish Kits",
          "alt": "Wood Finish Kits",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-POAK.png?v=1776107907&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_xl",
          "product_id": 6829888864390,
          "price": "$549.99",
          "price_num": 549.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-LW-LITE"] = {
  "meta": {
    "appearance": {
      "border_color": "#767676",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 20,
      "text_size_desktop": 30,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 2,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 6,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 20,
      "text_size_desktop": 30,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#e7e7e7",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h2>Light Wood Size Options</h2>",
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 40,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "60",
          "scale": "60",
          "product_image_scale": "60",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Jar-3D_c7c4885f-6089-4f92-bf4f-f2a5d3db8715.png?v=1775828854&width=400",
          "product_url": "/products/lw_lite_s",
          "product_id": 7572121550982,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$22.99",
          "price_num": 22.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/lw_lite_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "60",
          "scale": "60",
          "product_image_scale": "60",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-1_71aba879-b664-4b66-a7d7-3a3477fc5359.png?v=1763486981&width=400",
          "product_url": "/products/retq-lightwood",
          "product_id": 6701984055430,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$32.99",
          "price_num": 32.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/retq-lightwood",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW32-LITE-1_eb1da2e4-02f9-4be5-9779-9ef9382124bb.png?v=1774459466&width=400",
          "product_url": "/products/lw_lite_l",
          "product_id": 7572124762246,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$39.99",
          "price_num": 39.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/lw_lite_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-1_2e1601a7-5852-4de0-9b77-46cb8af5c3d1.png?v=1763739619&width=400",
          "product_url": "/products/lw_lite_xl",
          "product_id": 7572125286534,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$159.99",
          "price_num": 159.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/lw_lite_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "subheading": "<h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18637804470406__csw_custom_swatch_picker_6406c548-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz (Jar) - 25 square feet</li>\n    <li>16 oz (Pt) - 50 square feet</li>\n    <li>32 oz (Qt) - 100 square feet</li>\n    <li>128 oz (Gal) - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": "0",
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-LW-BLCH"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-LW-LITE"
  },
  "rows": [
    {
      "heading": "<h2>Light Wood Size Options</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Jar-3D_45913a0e-3b62-4c50-b912-10fd486c26ab.png?v=1775828948&width=400",
          "product_url": "/products/lw_blch_s",
          "product_id": 7572161921158,
          "price": "$22.99",
          "price_num": 22.99,
          "available": true,
          "cta": {
            "href": "/products/lw_blch_s",
            "text": "Shop"
          },
          "swatch_image_zoom": "60",
          "scale": "60",
          "product_image_scale": "60"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-1_018be9cc-3dce-488e-ab7f-3bd4b57d62f7.png?v=1763486662&width=400",
          "product_url": "/products/retq-bleachedwood",
          "product_id": 1943603150966,
          "price": "$29.99",
          "price_num": 29.99,
          "available": true,
          "cta": {
            "href": "/products/retq-bleachedwood",
            "text": "Shop"
          },
          "swatch_image_zoom": "60",
          "scale": "60",
          "product_image_scale": "60"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW32-BLCH-1.png?v=1774460507&width=400",
          "product_url": "/products/lw_blch_l",
          "product_id": 7572163526790,
          "price": "$39.99",
          "price_num": 39.99,
          "available": true,
          "cta": {
            "href": "/products/lw_blch_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-1_be3b4228-02b6-4ca5-a360-0bf67e86bd4d.png?v=1763739490&width=400",
          "product_url": "/products/lw_blch_xl",
          "product_id": 7572164116614,
          "price": "$159.99",
          "price_num": 159.99,
          "available": true,
          "cta": {
            "href": "/products/lw_blch_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "subheading": "<h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18637804470406__csw_custom_swatch_picker_42993fe1-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz (Jar) - 25 square feet</li>\n    <li>16 oz (Pt) - 50 square feet</li>\n    <li>32 oz (Qt) - 100 square feet</li>\n    <li>128 oz (Gal) - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-LW-DARK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-LW-LITE"
  },
  "rows": [
    {
      "heading": "<h2>Light Wood Size Options</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Jar-3D_3d11c1bc-1b93-4271-a245-11bdbfb4111c.png?v=1775829000&width=400",
          "product_url": "/products/lw_dark_s",
          "product_id": 7572175552646,
          "price": "$22.99",
          "price_num": 22.99,
          "available": true,
          "cta": {
            "href": "/products/lw_dark_s",
            "text": "Shop"
          },
          "swatch_image_zoom": "60",
          "scale": "60",
          "product_image_scale": "60"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-1_fb20c9bb-90f9-4aca-8670-4c613d919ff6.png?v=1763486820&width=400",
          "product_url": "/products/retq-darkwood",
          "product_id": 5187077865606,
          "price": "$32.99",
          "price_num": 32.99,
          "available": true,
          "cta": {
            "href": "/products/retq-darkwood",
            "text": "Shop"
          },
          "swatch_image_zoom": "60",
          "scale": "60",
          "product_image_scale": "60"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front_3D_b1554e48-1b82-413a-b9ba-1fcbbd63a5d2.png?v=1777578147&width=400",
          "product_url": "/products/lw_dark_l",
          "product_id": 7572175683718,
          "price": "$39.99",
          "price_num": 39.99,
          "available": true,
          "cta": {
            "href": "/products/lw_dark_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-1_37dcde33-4962-475f-8d82-a1035806cf54.png?v=1763739542&width=400",
          "product_url": "/products/lw_dark_xl",
          "product_id": 7572175716486,
          "price": "$159.99",
          "price_num": 159.99,
          "available": false,
          "cta": {
            "href": "/products/lw_dark_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "subheading": "<h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18637804470406__csw_custom_swatch_picker_c3365430-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz (Jar) - 25 square feet</li>\n    <li>16 oz (Pt) - 50 square feet</li>\n    <li>32 oz (Qt) - 100 square feet</li>\n    <li>128 oz (Gal) - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};